var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('InstrumentForm',{attrs:{"Instrument":_vm.question_test,"evaluation_id":_vm.evaluation_id,"TestForm":_vm.TestForm,"allows_crud":_vm.allows_crud,"show_delete_button":_vm.show_delete_button},on:{"created":_vm.save,"update_file":_vm.updateFile,"delete":_vm.askForDeleteQuestionTest}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }